import * as tslib_1 from "tslib";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { State, Mutation } from "vuex-class";
import AuthServiceFactory from "@/services/authentication/AuthServiceFactory";
let SideDrawerView = class SideDrawerView extends Vue {
    constructor() {
        super();
        this.authService = AuthServiceFactory.GetAuthService();
        this.isLoggedIn = false;
        this.user = null;
        this.mini = true;
        this.logo = "favicon.ico";
        this.applications = [
            {
                text: "Shop",
                icon: "fas fa-shopping-cart",
                roles: ["everyone"],
                links: [
                    {
                        to: "https://shop.aileron.org/login?ReturnURL=%2Fsearch%3Fst_t%3D2119%26st_ti%3D2759",
                        icon: "fas fa-calendar-check",
                        text: "Reservations",
                        external: true,
                        roles: ["everyone"]
                    },
                    {
                        to: "https://shop.aileron.org/login?ReturnURL=%2Fsearch%3Fst_t%3D2078%26st_ti%3D2521",
                        icon: "fas fa-chalkboard-teacher",
                        text: "Registrations",
                        external: true,
                        roles: ["everyone"]
                    }
                ]
            },
            {
                text: "Accounting",
                icon: "fas fa-calculator",
                roles: ["accounting"],
                links: [
                    {
                        to: "/accounting/transaction-history",
                        icon: "fas fa-file-invoice",
                        text: "Transaction History",
                        external: false,
                        roles: ["accounting"]
                    }
                ]
            },
            {
                text: "Content Portal",
                icon: "fas fa-calculator",
                roles: ["document-management"],
                links: [
                    {
                        to: "/document-management/file-explorer",
                        icon: "fas fa-file-invoice",
                        text: "Manage Documents",
                        external: false,
                        roles: ["document-management"]
                    }
                ]
            }
        ];
        this.setDrawer(true);
    }
    get drawerState() {
        return this.$store.state.drawer;
    }
    get myApplications() {
        let myApps = new Array();
        if (this.user != null) {
            for (let appIdx = 0; appIdx < this.applications.length; appIdx++) {
                let app = this.applications[appIdx];
                if (app.roles != undefined && app.roles.length > 0) {
                    for (let roleIdx = 0; roleIdx < app.roles.length; roleIdx++) {
                        if (app.roles[roleIdx] === "everyone") {
                            myApps.push(app);
                            break;
                        }
                        else if (this.user.profile.groups.indexOf(app.roles[roleIdx]) > -1) {
                            myApps.push(app);
                            break;
                        }
                    }
                }
                else {
                    myApps.push(app);
                }
            }
        }
        return myApps;
    }
    async mounted() {
        this.isLoggedIn = await this.authService.isLoggedIn();
        this.user = await this.authService.getUser();
    }
    set drawerState(value) {
        this.setDrawer(value);
    }
    get mini() {
        return this.$store.state.mini;
    }
    set mini(value) {
        this.setMini(value);
    }
};
tslib_1.__decorate([
    Prop({ type: Boolean, default: false })
], SideDrawerView.prototype, "opened", void 0);
tslib_1.__decorate([
    State("image")
], SideDrawerView.prototype, "image", void 0);
tslib_1.__decorate([
    State("color")
], SideDrawerView.prototype, "color", void 0);
tslib_1.__decorate([
    Mutation("setDrawer")
], SideDrawerView.prototype, "setDrawer", void 0);
tslib_1.__decorate([
    Mutation("toggleDrawer")
], SideDrawerView.prototype, "toggleDrawer", void 0);
tslib_1.__decorate([
    Mutation("setMini")
], SideDrawerView.prototype, "setMini", void 0);
tslib_1.__decorate([
    Mutation("toggleMini")
], SideDrawerView.prototype, "toggleMini", void 0);
SideDrawerView = tslib_1.__decorate([
    Component({
        name: "SideDrawer",
        components: {}
    })
], SideDrawerView);
export default SideDrawerView;
